export default {"src":"/_next/static/media/night.f2f93920.svg","height":17,"width":16};